// SLICK SLIDER
tetloose.slickSlider = function () {
    var $carousel = $('[rel=js-carousel]');
    if ($carousel) {
        $carousel.each(function() {
            var $t = $(this),
                $items = $t.find('[rel=js-carousel__item]'),
                $pagination = $t.parent().find('[rel=js-carousel-pagination]');

            if ($items.length < 2) {
                $pagination.hide();
            }

            $t.slick( {
                speed: 500,
                autoplaySpeed: 10000,
                slidesToShow: 1,
                infinite: true,
                autoplay: true,
                appendArrows: $pagination,
                prevArrow: $pagination.find('[rel=js-carousel-prev]'),
                nextArrow: $pagination.find('[rel=js-carousel-next]'),
                draggable: true,
                adaptiveHeight: true,
                responsive: [{
                  breakpoint: $mediumMq,
                  settings: {
                    autoplay: false,
                  }
                }]
            });

            $pagination.on('click', 'a', function(e) {
                e.preventDefault();
            });

        });
    }
};
